import type { ChainId } from '@morpho-org/blue-sdk'
import type { QueryClient } from '@tanstack/react-query'
import type { Address } from 'viem'

import { useQuery } from '@tanstack/react-query'

import { orpc } from '@/lib/orpc/client'

export interface VaultV2ApyQueryInput {
  chainId: ChainId
  address: Address
}

const VAULT_V2_APY_STALE_TIME_MS = 60_000

export const getVaultV2ApyQueryOptions = (input: VaultV2ApyQueryInput) =>
  orpc.vaultV2.apy.queryOptions({ input, staleTime: VAULT_V2_APY_STALE_TIME_MS })

export const useVaultV2ApyQuery = (input: VaultV2ApyQueryInput) => {
  return useQuery(getVaultV2ApyQueryOptions(input))
}

export const prefetchVaultV2ApyQuery = (queryClient: QueryClient, input: VaultV2ApyQueryInput) =>
  queryClient.prefetchQuery(getVaultV2ApyQueryOptions(input))
